// extracted by mini-css-extract-plugin
export default {"header":"header_TESDt","header-container":"header-container_u9RFR","title":"title_Zgynk"};